module.exports = __webpack_public_path__ + "img/master.c29ee512.png";